import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { PageMeta } from "@/components/shared";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    meta: "How SafetySymbiosis handles your information",
    body: [
      ["Who we are", "SAFETY SYMBIOSIS LTD (trading as SafetySymbiosis), company number 15885104, registered office 76 Fenlake Road, Bedford, Bedfordshire, MK42 0ET, United Kingdom, is the data controller responsible for the personal information described in this policy."],
      ["Information we collect", "When you contact us through our enquiry form, email or WhatsApp, we collect the details you provide — typically your name, company, email address, telephone number and information about your requirement."],
      ["How website enquiries are handled", "Enquiry details submitted through our website form are processed by our form provider, Web3Forms, which passes them to us by email at enquiries@safetysymbiosis.com. The website itself is a static site and does not store your details in its own database."],
      ["How we use it", "We use your information solely to respond to your enquiry, provide consultancy services and maintain necessary business records. We do not sell or share your information with third parties for marketing purposes."],
      ["Storage & retention", "Your enquiry is kept in our email records and retained only for as long as needed to handle your enquiry and meet our business obligations."],
      ["Your rights", "You may request access to, correction of, or deletion of your personal information. Deletion requests can be made by emailing enquiries@safetysymbiosis.com."],
    ],
  },
  cookies: {
    title: "Cookie Policy",
    meta: "Cookies used on this website",
    body: [
      ["No advertising or tracking cookies", "This website does not use advertising cookies and does not use tracking cookies. Nothing is placed in your browser to identify you or to follow you across other websites."],
      ["Analytics", "If we measure how the website is used, we may use privacy-friendly, cookie-free analytics. These do not store information on your device and are not used to build a personal profile."],
      ["No consent banner", "Because this website sets no advertising or tracking cookies, it does not display a cookie consent banner."],
      ["Managing cookies", "You can control or delete cookies through your browser settings at any time."],
    ],
  },
  terms: {
    title: "Terms & Conditions",
    meta: "Use of this website",
    body: [
      ["Use of this site", "This website provides information about SafetySymbiosis and its HSE/SHEQ consultancy services. Content is provided in good faith for general information only."],
      ["Intellectual property", "All website content, including the SafetySymbiosis name and logo, is the property of SafetySymbiosis and may not be reproduced without permission."],
      ["Professional engagement", "Nothing on this website constitutes a contractual offer. Services are provided under individually agreed terms."],
      ["Governing law", "Use of this website is governed by the laws of England and Wales."],
      ["Company information", "Registered in the UK since 2014. SAFETY SYMBIOSIS LTD (trading as SafetySymbiosis), company number 15885104, registered office 76 Fenlake Road, Bedford, Bedfordshire, MK42 0ET, United Kingdom."],
    ],
  },
};

export default function Legal({ kind }) {
  const c = CONTENT[kind] || CONTENT.privacy;
  return (
    <>
      <PageMeta
        title={`${c.title} | SafetySymbiosis`}
        description={c.meta}
      />
      <section className="bg-white py-14 lg:py-20">
        <div className="wrap max-w-4xl">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm font-semibold text-brand-green hover:underline"
            data-testid="legal-back-link"
          >
            <ArrowLeft className="h-4 w-4" />
            Back to Home
          </Link>
          <h1 className="mt-6 font-heading text-3xl font-extrabold tracking-tight sm:text-4xl">
            {c.title}
          </h1>
          <p className="mt-3 text-sm text-brand-charcoal/70">{c.meta}</p>
          <div className="mt-10 space-y-8">
            {c.body.map(([h, p]) => (
              <div key={h}>
                <h2 className="font-heading text-lg font-bold">{h}</h2>
                <p className="mt-2 text-sm leading-relaxed text-brand-charcoal/85">{p}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
